<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="show" class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <form method="POST">
                <div class="mb-5">
                    <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                            <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                        </svg>

                    </div>
                    <div class="mt-2 text-center">
                        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                            Update Contact Information
                        </h3>
                        <div v-if="! sendStartMessage" class="mt-3 text-left">
                            <p class="mb-4 text-sm font-medium">Provide your updated e-mail address and mobile phone number to receive receipts, reminders, or general notifications regarding your account.</p>

                            <label for="email" class="block font-semibold text-gray-700 mb-2">
                                Email
                            </label>
                            <input v-model="email"
                                   type="text"
                                   name="email"
                                   id="email"
                                   :class="`py-3 px-4 rounded bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 relative block w-full rounded-md bg-transparent focus:z-10 sm:text-sm border-gray-300`"
                                   placeholder="Your email">
                            <span v-if="emailError" class="block text-xs text-red-500 mt-1" v-text="emailError" />
                            <span v-else-if="emailError === false" class="block text-xs text-green-500 mt-1">That email address is valid.</span>

                            <label for="email" class="block font-semibold text-gray-700 mt-4 mb-2">
                                Mobile Phone Number
                            </label>
                            <the-mask
                                :mask="'(F##) ###-####'"
                                v-model="phoneNumber"
                                :placeholder="'Your mobile phone number'"
                                :type="'tel'"
                                name="phone_number"
                                id="phone_number"
                                :tokens="hexTokens"
                                :class="`py-3 px-4 rounded bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 relative block w-full rounded-md bg-transparent focus:z-10 sm:text-sm border-gray-300`"/>
                            <span v-if="numberError" class="block text-xs text-red-500 mt-1" v-text="numberError" />
                        </div>
                        <div v-else>
                            <p class="mt-4 text-sm font-medium">You've opted out, you must send "START" to {{ sendStartMessage }} to re-subscribe.</p>
                        </div>
                    </div>
                </div>
                <div  class="sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                    <button v-if="sendStartMessage"
                        type="button"
                        @click.prevent="() => { sendStartMessage = null; $emit('close'); }"
                            :class="`w-full inline-flex text-black items-center justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-${$root.theme}-300 text-base font-medium hover:bg-${$root.theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:col-start-2 sm:text-sm`">
                        Done
                    </button>
                    <template v-else>
                        <button @click.prevent="saveBoth" :class="{
                            [`w-full inline-flex text-black items-center justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-${$root.theme}-300 text-base font-medium hover:bg-${$root.theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:col-start-2 sm:text-sm`]: true,
                        }" class="">
                            <i v-if="loading" class="fa fa-spinner fa-spin text-black"></i>
                            <template v-else>Save</template>
                        </button>
                        <button @click="$emit('close')" type="button" :class="`mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-500 sm:mt-0 sm:col-start-1 sm:text-sm`">
                            Nevermind
                        </button>
                    </template>
                </div>
            </form>
        </div>
    </transition>
</template>

<script>
    import validatesAndSavesContactInformation from "../../mixins/validatesAndSavesContactInformation";

    export default {
        mixins: [validatesAndSavesContactInformation],

        props: ['show', 'account'],

        data() {
            return {
                emailRequired: false,
                numberRequired: false,
            };
        },

        methods: {
            done() {
                this.$emit('close');
            }
        }
    }
</script>
